import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthenticationService } from '../services/authentification.service';

/*
@Injectable({ providedIn: 'root' })
export class AuthGuard  {
    constructor(
        private router: Router,
        private authenticationService: AuthenticationService
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const currentUser = this.authenticationService.currentUserValue;
        console.log(currentUser);

        if (currentUser && new Date(currentUser.auth.token.expires_at).getTime() > new Date().getTime() ) {
            if(!currentUser.verified){
                if(state.url !== '/dashboard'){
                    this.router.navigate(['/dashboard']);
                    return false;
                }
                return true;
            }
            return true;
        }
        else{
            // not logged in so redirect to login page with the return url
            this.authenticationService.removeCurrentUser();
            this.router.navigate(['/signin'], { queryParams: { returnUrl: state.url }});
            return false;
        }
    }
}*/

export const AuthGuard: CanActivateFn = (route, state) => {
  const authenticationService = inject(AuthenticationService)
  const router = inject(Router)
  const currentUser = authenticationService.getCurrentUserInfos();
  //console.log(currentUser)
  if (currentUser && new Date(currentUser.auth.token.expires_at).getTime() > new Date().getTime() ) {
    if(!currentUser.verified){
        if(state.url !== '/dashboard'){
            router.navigate(['/dashboard']);
            //alert('pas verifier')
            return false;
        }
        return true;
    }


    return true;
  }else{
    // not logged in so redirect to login page with the return url
    authenticationService.removeCurrentUser();
    router.navigate(['/signin'], { queryParams: { returnUrl: state.url }});
    return false;
}

};

